import { Component, ElementRef, EventEmitter, OnDestroy, Output, ViewChild } from '@angular/core';
import { FclComponent } from '../fcl/fcl.component';
import { ResourceModel } from '../../../models/resources/resource.model';
import {ResourceType} from '../../../helpers/Const';
import { FileUploadService } from '../../../../service/services/misc/file-upload/file-upload.service';
import { NotificationsService } from '../../../../service/services/misc/notifications/notifications.service';
import { Subject, Subscription } from 'rxjs';
import { DialogService } from '../../../../service/services/misc/dialog/dialog.service';
import { ContentDetailsComponent } from '../../../../features/organizations/misc/content-details/content-details.component';
import { DisplayedColumn } from '../../../models/misc/displayed-column.model';
import { TableComponent } from '@fundamental-ngx/core';
import { TablePersonalizationService } from '../../../../service/services/misc/table-personalization/table-personalization.service';
import { TablePersonalizationDefinitions } from '../../../helpers/TablePersonalizationDefinitions';
import { SwaService } from '../../../../service/services/misc/swa/swa.service';
import { DataTableComponent } from '../../../../shared/components/data-table/data-table.component';
import { Utils } from '../../../helpers/Utils';
import { AppConfigService } from "../../../../service/services/misc/app-config/app-config.service";
import {UisService} from "../../../../service/services/misc/uis/uis.service";
import {NavigationStart, Router} from "@angular/router";

@Component({ template: '', standalone: false })
export class ResourceFclComponent extends FclComponent implements OnDestroy {
	@ViewChild('file')
	    fileInput: ElementRef;

	forkReqSubject: Subject<number> = new Subject();
	ascending = true;
	sortProperty: string;
	currentHoverItem: ResourceModel | null;
	currentOpenActionsheetRow: ResourceModel | null;
	selectedParentImportResource: ResourceModel;
	subscriptions: Subscription[] = [];
	@Output() toggleFclMain = new EventEmitter<boolean>();
  @Output() loadingFinished: EventEmitter<boolean> = new EventEmitter<boolean>();
  public currentTableKey: string = TablePersonalizationDefinitions.ResourcesTable.key;
  protected currentTableSubscription: Subscription;

	@ViewChild('contentDetailsComponent')
	    contentDetailsComponent: ContentDetailsComponent;

	@ViewChild(TableComponent)
	    tableComponent: TableComponent;

	@ViewChild(DataTableComponent)
	    dataTable: DataTableComponent;
	queryUid: string;
	labelTextMapping: { [k: string]: string } = {
	    '=1': $localize`:@@organizations.table.labelsButtonText.oneLabel:1 label`,
	    other: $localize`:@@organizations.table.labelsButtonText.multipleLabels:# labels`,
	};
	annotationTextMapping: { [k: string]: string } = {
	    '=1': $localize`:@@organizations.table.annotationsButtonText.oneAnnotation:1 annotation`,
	    other: $localize`:@@organizations.table.annotationsButtonText.multipleAnnotations:# annotations`,
	};
	displayedColumns: string[];
	currentDisplayedColumns: DisplayedColumn[];

	constructor(
		protected _fileUploadService: FileUploadService,
		protected _notificationService: NotificationsService,
		protected _dialogService: DialogService,
		protected _tablePersonalizationService: TablePersonalizationService,
		protected swaService: SwaService,
		protected  appConfigService: AppConfigService,
		protected uisService: UisService,
		protected router: Router
	) {
	    super();
	    this.displayedColumns = [];
	    this.loading = false;
	}

	ngOnDestroy() {
	    this.subscriptions.forEach((s) => s.unsubscribe());
	    this.forkReqSubject.next(1);
	}

	selectRow(row: ResourceModel, forceOpen: null | boolean): void {
	    if (Utils.hasFeatureFlag('softSelect') && !forceOpen) {
			  this.selectedRow = this.isFclClosed() && this.selectedRow === row ? null : row;
  		} else {
	  		this.toggleFcl(row);
		  }
	}
	compareByUID(selectedRow: ResourceModel, row: ResourceModel): boolean {
	    return (selectedRow?.uid === row?.uid);
	}
	findSelectedRow(selectedRow: ResourceModel, row: ResourceModel): boolean {
	    return selectedRow && row &&
			this.compareByUID(selectedRow, row);
	}

	toggleFcl(row: ResourceModel): void {
	    this.swaService.sendCustomEvent(this.swaService.SWA_EVENT_TYPES.OPEN_FCL_DETAILS, [row ? row.type : 'non-row'], []);
	    if (row !== null && (this.selectedRow === undefined || this.isFclClosed())) {
	        this.openFcl(row);
	        this.localLayout = 'TwoColumnsMidExpanded';
	    } else if (!this.findSelectedRow(this.selectedRow, row)) {
	        this.selectedRow = row;
	    } else {
	        this.closeFcl();
	    }
	    this.propagateChangeToDisplayedValue(this.currentDisplayedColumns);
	}

	openPolicies(row: ResourceModel): void {
	    this.swaService.sendCustomEvent(this.swaService.SWA_EVENT_TYPES.OPEN_POLICIES_TAB, [row.type], []);
	    this.toggleFcl(row);
	    this.contentDetailsComponent.openPoliciesTab(row);
	}

	openReferences(row: ResourceModel): void {
	    this.swaService.sendCustomEvent(this.swaService.SWA_EVENT_TYPES.OPEN_REFERENCES_TAB, [row.type], []);
	    this.toggleFcl(row);
	    this.contentDetailsComponent.openReferencesTab(row);
	}

	openEvents(row: ResourceModel): void {
	    this.swaService.sendCustomEvent(this.swaService.SWA_EVENT_TYPES.OPEN_EVENTS_TAB, [row.type], []);
	    this.toggleFcl(row);
	    this.contentDetailsComponent.openEventsTab(row);
	}

	openRTDResources(row: ResourceModel): void {
	    this.swaService.sendCustomEvent(this.swaService.SWA_EVENT_TYPES.OPEN_RTD_RESOURCES_TAB, [row.type], []);
	    this.toggleFcl(row);
	    this.contentDetailsComponent.openRTDResourcesTab(row);
	}

	openDetails(row: ResourceModel): void {
	    this.uisService.sendUISEvent(this.uisService.UIS_EVENT_TYPES.OPEN_DETAILS_TAB + " - "
			+ (row ? row.type : 'non-row'), {type: (row? row.type : 'non-row'), path: row? row.path: ''});
	    this.swaService.sendCustomEvent(this.swaService.SWA_EVENT_TYPES.OPEN_DETAILS_TAB, [row.type], []);
	    if(this.isFclClosed()) {
	        this.toggleFcl(row);
	    } else {
	        this.openFcl(row);
	    }
	    this.contentDetailsComponent.detailsTab.open(true);
	}

	override closeFcl() {
	    this.swaService.sendEvent(this.swaService.SWA_EVENT_TYPES.CLOSE_FCL_DETAILS);
	    super.closeFcl();
	    this.toggleFclMain.emit(false);
	    this.propagateChangeToDisplayedValue(this.currentDisplayedColumns);
	}

	protected openFcl(row: ResourceModel) {
	    this.selectedRow = row;
	    this.toggleFclMain.emit(true);
	}

	isSelected(row: ResourceModel): boolean {
	    return this.findSelectedRow(this.selectedRow, row);
	}

	onImport(resource: ResourceModel) {
	    this.uisService.sendUISEvent(this.uisService.UIS_EVENT_TYPES.FCL_IMPORT_CLICKED + " - "
			+ resource.type, {type: resource.type, path: resource.path});
	    this.swaService.sendCustomEvent(this.swaService.SWA_EVENT_TYPES.FCL_IMPORT_CLICKED, [resource.type], []);
	    this.fileInput.nativeElement.click();
	    this.selectedParentImportResource = resource;
	}

	handleFileInputChange() {
	    const file = this.fileInput.nativeElement.files[0];
	    this.import(file, this.selectedParentImportResource);
	}

	import(file: File, parentResource: ResourceModel) {
	    this.loading = true;
	    this._fileUploadService
	        .postFile(file, parentResource)
	        .subscribe({
	            next: (e) => {
	                this._notificationService.showMessageToast('YAML configuration file imported successfully.');
	            },
	            error: (e) => {
	                console.log('error');
	            },
	        })
	        .add(() => {
	            this.loading = false;
	        });
	}

	sort(asc: boolean, prop: string) {
	    this.ascending = asc;
	    this.sortProperty = prop;
	}

	isNavigable(type: string) {
	    return (
	        type === ResourceType.FOLDER || type === ResourceType.RESOURCE_GROUP || type === ResourceType.ORGANIZATION
	    );
	}

	onHoverRow(row: ResourceModel | null) {
	    this.currentHoverItem = row;
	}

	setIsActionSheetOpen(obj: any) {
	    this.isActionSheetOpen = obj.isOpen;
	    if (!this.isActionSheetOpen) {
	        this.currentOpenActionsheetRow = null;
	        return;
	    }
	    this.currentOpenActionsheetRow = obj.item;
	}

	onLayoutChange() {
	    this.uisService.sendEvent(this.uisService.UIS_EVENT_TYPES.FCL_LAYOUT_SIZE_CLICKED);
	    this.swaService.sendCustomEvent(this.swaService.SWA_EVENT_TYPES.FCL_LAYOUT_SIZE_CLICKED, [this.localLayout], []);
	    this.propagateChangeToDisplayedValue(this.currentDisplayedColumns);
	}

	subscribeToTablePersonalizationChange() {
	    this.subscriptions.push(
	        this._tablePersonalizationService
	            .getTableSubject(TablePersonalizationDefinitions.ResourcesTable.key)
	            .columnsSubject.subscribe((columns: DisplayedColumn[]) => {
	                this.propagateChangeToDisplayedValue(columns);
	            })
	    );
	}

	initDatatablePersistency(path: string) {
	    try {
	        const filterPersistencyAdditionalData = this.dataTable.getFilterPersistencyCache()?.additionalData;
	        const sortPersistencyAdditionalData = this.dataTable.getSortPersistencyCache()?.additionalData;
	        if ((!!sortPersistencyAdditionalData && sortPersistencyAdditionalData !== path) ||
				(!!filterPersistencyAdditionalData && filterPersistencyAdditionalData !== path)) {
	            this.dataTable.reset();
	        }
	    } catch (e) {
	        console.error(e);
	    }
	}

	subscribeToNavigationStart() {
	    this.subscriptions.push(this.router.events.subscribe(event => {
	        if(event instanceof NavigationStart) {
	            this.dataTable?.reset();
	        }
	    }));
	}

	propagateChangeToDisplayedValue(currentDisplayedColumns: DisplayedColumn[]): void {
	    this.currentDisplayedColumns = currentDisplayedColumns;
	    this.displayedColumns = [
	        ...currentDisplayedColumns
	            .filter((col) => col.checked && col.visibleIn?.includes(this.localLayout))
	            .map((col) => col.key),
	    ];
	    if (this.tableComponent) {
	        this.tableComponent.reset(this.displayedColumns);
	    }
	}

	showButtons(row: any): boolean {
	    return (
	        (row && this.findSelectedRow(this.selectedRow, row)) ||
			this.currentHoverItem === row ||
			this.currentOpenActionsheetRow === row
	    );
	}

	setLoading(loading: boolean) {
	    this.loading = loading;
	    this.loadingFinished.emit(!loading);
	}

	/**
	 * Switch between regular table and advanced search table personalization.
	 * Each table key maintains its own column visibility settings in localStorage.
	 */
	protected switchTablePersonalization(tableKey: string): void {
	    // Update the current table key (used by template)
	    this.currentTableKey = tableKey;

	    // Unsubscribe from current table personalization
	    if (this.currentTableSubscription) {
	        this.currentTableSubscription.unsubscribe();
	        const index = this.subscriptions.indexOf(this.currentTableSubscription);
	        if (index > -1) {
	            this.subscriptions.splice(index, 1);
	        }
	    }

	    // Get the table subject for the new key
	    const tableSubject = this._tablePersonalizationService.getTableSubject(tableKey);

	    // Immediately apply the current column configuration for the new table key
	    const currentColumns = tableSubject.columnsSubject.getValue();
	    this.propagateChangeToDisplayedValue(currentColumns);

	    // Subscribe to future changes to the new table personalization
	    this.currentTableSubscription = tableSubject.columnsSubject.subscribe((columns: DisplayedColumn[]) => {
	        this.propagateChangeToDisplayedValue(columns);
	    });

	    // Add to subscriptions array for cleanup
	    this.subscriptions.push(this.currentTableSubscription);
	}

}
